import { render, staticRenderFns } from "./VitalDisplay.vue?vue&type=template&id=320bfc62&scoped=true&"
import script from "./VitalDisplay.vue?vue&type=script&lang=ts&"
export * from "./VitalDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./VitalDisplay.vue?vue&type=style&index=0&id=320bfc62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320bfc62",
  null
  
)

export default component.exports